import { Injectable, inject, signal } from '@angular/core';
import { calculateDistance } from '@functions';
import { BoxDetection } from '@models';
import { ScreenService, TaskService } from '@services';

const MAX_MOVEMENT = 3;

@Injectable({
  providedIn: 'root',
})
export class MetricsService {
  private screenService = inject(ScreenService);
  private taskService = inject(TaskService);

  toolTracking = new Map<
    string,
    {
      previousPosition: { x: number; y: number } | undefined;
      totalDistance: number;
    }
  >();

  toolPaths = signal<{ [key: string]: number }>({});

  trackTool(tool: BoxDetection, identifier: string) {
    if (this.taskService.measureMetrics() && tool) {
      if (this.toolTracking.has(identifier)) {
        const distance =
          calculateDistance(
            this.toolTracking.get(identifier).previousPosition,
            {
              x: tool.center.x,
              y: tool.center.y,
            },
          ) * this.screenService.getCmPerPixel();

        const totalDistance =
          this.toolTracking.get(identifier).totalDistance +
          (distance < MAX_MOVEMENT ? distance : 0);

        this.toolTracking.set(identifier, {
          previousPosition: {
            x: tool.center.x,
            y: tool.center.y,
          },
          totalDistance,
        });
      } else {
        this.toolTracking.set(identifier, {
          previousPosition: {
            x: tool.center.x,
            y: tool.center.y,
          },
          totalDistance: 0,
        });
      }
      this.toolPaths.set({
        ...this.toolPaths(),
        [identifier]: Math.round(
          this.toolTracking.get(identifier)?.totalDistance ?? 0,
        ),
      });
    }
  }

  getToolDistance(identifier: string) {
    return this.toolTracking.get(identifier)?.totalDistance ?? 0;
  }
}
